import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { catchError, map, Observable, of } from 'rxjs';

import { Language } from '@customer-portal/shared';
import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { ProfileLanguageDto } from '../../../dtos';
import {
  PROFILE_LANGUAGE_MUTATION,
  PROFILE_LANGUAGE_QUERY,
} from '../../../graphql';

@Injectable({ providedIn: 'root' })
export class ProfileLanguageService {
  private clientName = APOLLO_CLIENT_NAMES.contact;

  constructor(private readonly apollo: Apollo) {}

  getProfileLanguage(): Observable<ProfileLanguageDto | null> {
    const fieldName =
      getQueryRootFieldName(PROFILE_LANGUAGE_QUERY) || 'userProfile';

    return this.apollo
      .use(this.clientName)
      .query({
        query: PROFILE_LANGUAGE_QUERY,
        variables: {},
        fetchPolicy: 'no-cache',
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result: any) => result?.data?.userProfile),
        catchError((_) => of(null)),
      );
  }

  updateProfileLanguage(language: Language): Observable<ProfileLanguageDto> {
    const fieldName =
      getQueryRootFieldName(PROFILE_LANGUAGE_MUTATION) || 'updateProfile';

    return this.apollo
      .use(this.clientName)
      .mutate({
        mutation: PROFILE_LANGUAGE_MUTATION,
        variables: {
          language,
        },
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((results: any) => results?.data?.updateProfile),
      );
  }
}
